import Post from 'components/ContentItem/Post';
import useTimeAgo from 'hooks/useTimeAgo';
import type { ArticlePreview, LatestConfig } from 'interfaces/content/articles/Articles';
import { ARTICLE_PAGE_TEST_IDS } from 'constants/testsIds/articlePage';
import { Wrapper, TimeAgo, PostWrapper, Title, LatestHeading, PostList } from './LatestStyles';

const LatestPopularContent = ({ content, trackingData, title, className }: LatestConfig) => {
  if (content.posts.length === 0) return null;
  const type = 'article-redesign-latest';
  const recirculationArray = content.posts.map((post) => post.title);

  return (
    <Wrapper
      className={`latest-popular-module ${className}`}
      data-cy={ARTICLE_PAGE_TEST_IDS.WRAPPER}
      data-recirculation-name={title}
      data-recirculation-array={recirculationArray}
    >
      <LatestHeading className='heading'>
        <Title
          as='h2'
          id='latest-popular-module'
          $fontFamily='saol'
          $size={{ default: 'level2' }}
          className='latest-popular-title'
          data-cy={ARTICLE_PAGE_TEST_IDS.TITLE}
        >
          {title}
        </Title>
      </LatestHeading>
      <PostList
        data-cy={ARTICLE_PAGE_TEST_IDS.POST_LIST}
        className='latest-popular-content'
      >
        {content.posts.map((post: ArticlePreview) => {
          const date = useTimeAgo(post.date);
          return (
            <PostWrapper
              key={post.title}
              className='content-wrapper'
              data-cy={ARTICLE_PAGE_TEST_IDS.CONTAINER}
            >
              <TimeAgo
                className='time-ago-wrapper'
                data-cy={ARTICLE_PAGE_TEST_IDS.TIME_AGO}
              >
                {date}
              </TimeAgo>
              <Post
                as='div'
                key={post.title}
                image={post.image}
                eyebrowSectionLabel={post.eyebrowSectionLabel}
                eyebrowSectionLink={post.eyebrowSectionLink}
                eyebrowTopicLabel={post.eyebrowTagLabel}
                eyebrowTopicLink={post.eyebrowTagLink}
                title={post.title}
                titleLink={post.titleLink || ''}
                authors={post.authors}
                date={post.date}
                type={type}
                trackingData={trackingData}
                className='content'
              />
            </PostWrapper>
          );
        })}
      </PostList>
    </Wrapper>
  );
};

export default LatestPopularContent;
